
<button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
    <i class="pi pi-ellipsis-v"></i>
</button>

<div class="layout-topbar-menu hidden lg:block">
    <div class="layout-topbar-menu-content">

        <p-button label="{{user()?.email}}" severity="secondary" rounded outlined>
            <i class="pi pi-user"></i>
        </p-button>

        <button type="button" class="layout-topbar-action" (click)="logout()" title="Logout">
            <i class="pi pi-sign-out"></i>
        </button>
    </div>
</div>
